import { LogRepository } from '../Repositories/LogRepository';
import { User } from '../../../User/Model/User';
import { canDeleteLogs } from '../../../../Utils/userPermissions';

export class DeleteLogUseCase {
  constructor(private repo: LogRepository) {}

  execute(logId: number, current: User): Promise<void> {
    if (!canDeleteLogs(current)) {
      throw new Error('제한형 관리자는 로그를 삭제할 수 없습니다.');
    }
    return this.repo.deleteLog(logId);
  }

  executeBulk(logIds: number[], current: User): Promise<void> {
    if (!canDeleteLogs(current)) {
      throw new Error('제한형 관리자는 로그를 삭제할 수 없습니다.');
    }
    return this.repo.bulkDeleteLogs(logIds);
  }
} 